/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PrizePool } from './PrizePool';
import {
    PrizePoolFromJSON,
    PrizePoolFromJSONTyped,
    PrizePoolToJSON,
    PrizePoolToJSONTyped,
} from './PrizePool';
import type { ChallengeSummaryUser } from './ChallengeSummaryUser';
import {
    ChallengeSummaryUserFromJSON,
    ChallengeSummaryUserFromJSONTyped,
    ChallengeSummaryUserToJSON,
    ChallengeSummaryUserToJSONTyped,
} from './ChallengeSummaryUser';
import type { QuestConfig } from './QuestConfig';
import {
    QuestConfigFromJSON,
    QuestConfigFromJSONTyped,
    QuestConfigToJSON,
    QuestConfigToJSONTyped,
} from './QuestConfig';

/**
 * 
 * @export
 * @interface ChallengeSummaryResponse
 */
export interface ChallengeSummaryResponse {
    /**
     * 
     * @type {Array<QuestConfig>}
     * @memberof ChallengeSummaryResponse
     */
    questConfigs: Array<QuestConfig>;
    /**
     * 
     * @type {Array<PrizePool>}
     * @memberof ChallengeSummaryResponse
     */
    prizePools: Array<PrizePool>;
    /**
     * 
     * @type {Array<ChallengeSummaryUser>}
     * @memberof ChallengeSummaryResponse
     */
    users: Array<ChallengeSummaryUser>;
}

/**
 * Check if a given object implements the ChallengeSummaryResponse interface.
 */
export function instanceOfChallengeSummaryResponse(value: object): value is ChallengeSummaryResponse {
    if (!('questConfigs' in value) || value['questConfigs'] === undefined) return false;
    if (!('prizePools' in value) || value['prizePools'] === undefined) return false;
    if (!('users' in value) || value['users'] === undefined) return false;
    return true;
}

export function ChallengeSummaryResponseFromJSON(json: any): ChallengeSummaryResponse {
    return ChallengeSummaryResponseFromJSONTyped(json, false);
}

export function ChallengeSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeSummaryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'questConfigs': ((json['questConfigs'] as Array<any>).map(QuestConfigFromJSON)),
        'prizePools': ((json['prizePools'] as Array<any>).map(PrizePoolFromJSON)),
        'users': ((json['users'] as Array<any>).map(ChallengeSummaryUserFromJSON)),
    };
}

export function ChallengeSummaryResponseToJSON(json: any): ChallengeSummaryResponse {
    return ChallengeSummaryResponseToJSONTyped(json, false);
}

export function ChallengeSummaryResponseToJSONTyped(value?: ChallengeSummaryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'questConfigs': ((value['questConfigs'] as Array<any>).map(QuestConfigToJSON)),
        'prizePools': ((value['prizePools'] as Array<any>).map(PrizePoolToJSON)),
        'users': ((value['users'] as Array<any>).map(ChallengeSummaryUserToJSON)),
    };
}

